import { FC } from 'react';
import { useField } from 'formik';
import { HTMLSelect, HTMLSelectProps } from '@blueprintjs/core';

import { FormGroup } from '../FormGroup';

interface IProps extends HTMLSelectProps {
    name: string;
    className?: string;
    label?: string;
    required?: boolean;
    isContinueBtnClicked?: boolean;
    withEmptyOption?: boolean;
    helperText?: string;
}
interface IFieldProps extends IProps {
    field?: { [key: string]: any };
    meta?: { [key: string]: any };
    isContinueBtnClicked?: boolean;
}

const emptyOption = {
    label: '',
    value: '',
};

export const SelectComponent: FC<IFieldProps> = ({
    className,
    label,
    required,
    field = {},
    meta = {},
    isContinueBtnClicked,
    withEmptyOption = false,
    helperText,
    ...props
}) => {
    if (withEmptyOption) {
        props.options = [emptyOption, ...(props.options || [])];
    }
    return (
        <FormGroup
            className={className}
            label={label}
            labelFor={props?.name}
            required={required}
            touched={meta?.touched || isContinueBtnClicked}
            helperText={helperText}
            error={meta?.error}
        >
            <HTMLSelect {...field} {...props} id={props?.name} className="v2__form-select-input" />
        </FormGroup>
    );
};

const SelectFormComponent: FC<IProps> = ({
    className,
    label,
    required,
    isContinueBtnClicked,
    withEmptyOption = false,
    ...props
}) => {
    const [field, meta] = useField(props);

    return (
        <SelectComponent
            className={className}
            label={label}
            required={required}
            field={field}
            meta={meta}
            isContinueBtnClicked={isContinueBtnClicked}
            withEmptyOption={withEmptyOption}
            {...props}
        />
    );
};

export default SelectFormComponent;
